import { useCallback, useRef, useState } from 'react';
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';

const PRISTINE_STATE_JSON = '[]';

export const FingerDraw = ({ onDataChanged }: { onDataChanged: (value: string) => void }) => {
  const canvasRef = useRef<ReactSketchCanvasRef>(null);

  const [saveData, setSaveData] = useState<string>('');
  const [src, setSrc] = useState<string>('/images/sign-here.png');

  const hasSignature = saveData !== PRISTINE_STATE_JSON;

  const checkAndUpdateData = useCallback(async () => {
    if (canvasRef.current) {
      const base64data = await canvasRef.current.exportImage('png');

      const saveData = await canvasRef.current.exportPaths();
      setSaveData(JSON.stringify(saveData));

      if (JSON.stringify(saveData) === PRISTINE_STATE_JSON) {
        setSrc('/images/sign-here.png');
        onDataChanged('');
      } else {
        setSrc('/images/empty.png');
        onDataChanged(base64data);
      }
    }
  }, [onDataChanged]);

  const onReset = useCallback(() => {
    canvasRef.current?.clearCanvas();
    void checkAndUpdateData();
  }, [checkAndUpdateData]);

  return (
    <div className="relative mb-5">
      <ReactSketchCanvas
        onStroke={checkAndUpdateData}
        strokeWidth={2}
        className="w-full h-25"
        strokeColor="#1EEB78"
        height="120px"
        ref={canvasRef}
        style={{
          borderColor: '#1EEB78',
          borderWidth: 2,
          borderStyle: 'solid',
          borderRadius: '1.25rem',
          overflow: 'hidden',
        }}
        backgroundImage={src}
      />

      {hasSignature && (
        <button
          className="absolute top-0 right-0 w-12.5 h-12.5 flex items-center justify-center"
          type="button"
          onClick={onReset}
        >
          <ClearButton className="text-green-laser" />
        </button>
      )}
    </div>
  );
};

const ClearButton = ({ className }: { className: string }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}>
    <path
      d="M17.2899 3.14924L14.8516 0.710938L8.99921 6.56335L3.14728 0.71142L0.708984 3.14972L6.56091 9.00165L0.709491 14.8531L3.14779 17.2914L8.99921 11.4399L14.8511 17.2919L17.2894 14.8536L11.4375 9.00165L17.2899 3.14924Z"
      fill="currentColor"
    />
  </svg>
);
